import React, { useEffect, useState } from "react";
import { ToastContainer } from "react-toastify";
import { RingLoader } from "react-spinners";
import NavBar from "components/SideBar/SideBar2";
import { useDispatch, useSelector } from "react-redux";
import FilterBar from "./FilterBar";
import SubFilterBar from "./SubFilterBar";
import Table from "./Table";
import {
  getBuyerGstinList,
  getEinvoiceData,
  getProfile,
  setCheckedCancelPayload,
  setCheckedIrnNotGenPayload,
  setCheckedIrnPayload,
} from "./action";

const EinvoiceNew = (props) => {
  const dispatch = useDispatch();
  const [pageNumber, setPageNumber] = useState(1);
  const [pageLimit, setPageLimit] = useState(50);
  const [gstinList, setGstinList] = useState([]);

  const {
    loaderStatus,
    searchStr,
    profileData,
    checkedIrn,
    checkedCancel,
    checkedIrnNotGen,
    supplierGstinFilter,
    receipientGstinFilter,
    selectedFromDate,
    selectedToDate,
  } = useSelector((state) => state.EinvReducerNew);

  const fetchEinvoiceData = (pageNo, statusCode) => {
    dispatch(
      getEinvoiceData(
        searchStr,
        pageNo,
        statusCode,
        supplierGstinFilter,
        receipientGstinFilter,
        selectedFromDate,
        selectedToDate
      )
    );
  };

  const handlePageClick = (value) => {
    setPageNumber(value.selected + 1);
    fetchEinvoiceData(
      value.selected + 1,
      checkedIrn === true
        ? 1
        : checkedCancel === true
        ? 2
        : checkedIrnNotGen === true
        ? 3
        : ""
    );
  };

  // useEffect(() => {
  //   if (profileData?.length > 0) {
  //     var Allprofile =
  //     profileData && profileData?.length > 0
  //       ? profileData.map((v) => ({ ...v, label: v.gstin }))
  //       : [];
  //     var profileList =
  //       Allprofile && Allprofile?.length > 0
  //         ? Allprofile.filter((form) => form.profileType == "EINV")
  //         : [];
  //     // Extract GSTINs and format them for DropdownTreeSelect
  //     const formattedData = profileList.map((profile) => ({
  //       label: profile.gstin,
  //       value: profile.gstin,
  //       children: [], // Empty since it's not hierarchical
  //     }));
  //     // const formattedData = profileData.map((profile) => ({
  //     //   label: profile.gstin,
  //     //   value: profile.gstin,
  //     //   children: [], // Empty since it's not hierarchical
  //     // }));
  //     setGstinList(formattedData);
  //   }
  // }, [profileData]);

  // useEffect(() => {
  //   if (!profileData?.length) return;

  //   const profileList = profileData
  //     .filter((profile) => profile.profileType === "EINV")
  //     .map((profile) => ({
  //       label: profile.gstin,
  //       value: profile.gstin,
  //       children: [], // Not hierarchical
  //     }));

  //   setGstinList(profileList);
  // }, [profileData]);

  useEffect(() => {
    fetchEinvoiceData();
    dispatch(getProfile());
  }, []);

  useEffect(() => {
    dispatch(setCheckedCancelPayload(false));
    dispatch(setCheckedIrnPayload(false));
    dispatch(setCheckedIrnNotGenPayload(false));
  }, []);

  useEffect(() => {
    if (!profileData?.length) return;

    const profileList = profileData
      .filter((profile) => profile.profileType === "EINV")
      .map((profile) => profile.gstin);

    setGstinList(profileList);
  }, [profileData]);

  useEffect(() => {
    dispatch(getBuyerGstinList());
  }, []);

  return (
    <>
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnVisibilityChange
        draggable
        pauseOnHover
      />
      <div className="sweet-loading">
        <RingLoader size={100} color={"#4f2d7f"} loading={loaderStatus} />
      </div>
      <NavBar
        currentPage="E-Invoice and E-Way Bill | E-invoice"
        module="eInv"
        history={props.history}
      >
        <FilterBar
          fetchEinvoiceData={fetchEinvoiceData}
          setPageNumber={setPageNumber}
        />
        <SubFilterBar
          fetchEinvoiceData={fetchEinvoiceData}
          profileList={gstinList}
          pageNumber={pageNumber}
          setPageNumber={setPageNumber}
          gstinList={gstinList}
        />
        <Table
          handlePageClick={handlePageClick}
          fetchEinvoiceData={fetchEinvoiceData}
          pageNumber={pageNumber}
        />
      </NavBar>
    </>
  );
};

export default EinvoiceNew;
